import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import "./../../../../styles/FactCheckCard.css";
import FactCheckCardSkeleton from "./FactSkeleton";

const FactCheckCard = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const truncate = (text, limit) => {
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  return (
    <>
      <div>
        <div className="fact-card">
          <div className="fact-card-image-container">
            <img
              src={data.imageLink || "n/a"}
              alt="N/A"
              className="fact-card-image"
              loading="lazy"
            />
            <div className="fact-card-badge">
              <span>{data.site}</span>
            </div>
          </div>

          <div className="fact-card-content">
            <h3 className="fact-card-title">{data.title}</h3>
            <div className="fact-card-meta">
              <span>{new Date(data.dateTime).toLocaleDateString()}</span>
              <span className="meta-separator">•</span>
              <span>{data.author}</span>
            </div>
            <p className="fact-card-description">
              {truncate(data.description, 500)}
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="fact-card-button"
            >
              <span>View Details</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        <Modal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h2>{data.title}</h2>
              <button
                className="modal-close-button"
                onClick={() => setIsModalOpen(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <img src={data.imageLink} alt="N/A" className="modal-image" />
              <div className="modal-info">
                <div className="info-group">
                  <strong>Author:</strong> {data.author}
                </div>
                <div className="info-group">
                  <strong>Date:</strong> 
                  {new Date(data.dateTime).toLocaleString()}
                </div>
                <div className="info-group">
                  <strong>Site:</strong> {data.site}
                </div>
                <div className="info-group full-width">
                  <strong>Fact:</strong> 
                  {data.fact_translation && data.fact_translation !== "n/a"
                    ? data.fact_translation
                    : data.fact}
                </div>
              </div>
              <div className="modal-footer">
                <a
                  href={data.link}
                  target="_blank"
                  rel="noreferrer"
                  className="read-more-link"
                >
                  Read Full Article
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                </a>
                {/* <button
                className="modal-button"
                onClick={() => setIsModalOpen(false)}
              >
                Close
              </button> */}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default FactCheckCard;
